import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import { useMobile } from '@/hooks'
import { useScheduledCommunications } from '@/hooks/useScheduledCommunications/useScheduledCommunications'

import { MobileScheduledCommunicationCard } from './MobileScheduledCommunications'
import { ScheduledCommunicationListColumns } from './ScheduledCommunications.data'
import { ScheduledCommunicationsFilterBar } from './ScheduledCommunicationsFilterBar'

export const ScheduledCommunications = () => {
  const { data: scheduledCommunicationsData, refetch, isLoading } = useScheduledCommunications()

  const data = useMemo(() => {
    return scheduledCommunicationsData && scheduledCommunicationsData?.scheduledCommunications
      ? scheduledCommunicationsData.scheduledCommunications
      : []
  }, [scheduledCommunicationsData])

  const { isMobile } = useMobile()

  const columns = useMemo(() => {
    return ScheduledCommunicationListColumns(refetch)
  }, [refetch])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <div className="mb-2 flex w-full items-center justify-between md:mb-8 md:flex-row">
        <h2 className=" text-header-lg leading-120">Scheduled Communications</h2>
      </div>
      <ScheduledCommunicationsFilterBar />

      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            data && data?.length > 0 ? (
              data?.map((scheduledCommunication, index) => (
                <MobileScheduledCommunicationCard key={index} scheduledCommunication={scheduledCommunication} />
              ))
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
